var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03662 3.8745C3.03662 2.35707 4.28301 1.12695 5.82051 1.12695H9.86978C10.2891 1.12695 10.629 1.46244 10.629 1.87628C10.629 2.29013 10.2891 2.62561 9.86978 2.62561H5.82051C5.12164 2.62561 4.55511 3.18475 4.55511 3.8745V4.8736C4.55511 5.28744 4.21518 5.62293 3.79586 5.62293C3.37655 5.62293 3.03662 5.28744 3.03662 4.8736V3.8745ZM3.79586 14.1154C4.21518 14.1154 4.55511 14.4508 4.55511 14.8647V15.8637C4.55511 16.5535 5.12164 17.1126 5.82051 17.1126H9.86978C10.2891 17.1126 10.629 17.4482 10.629 17.862C10.629 18.2758 10.2891 18.6113 9.86978 18.6113H5.82051C4.28301 18.6113 3.03662 17.3812 3.03662 15.8637V14.8647C3.03662 14.4508 3.37655 14.1154 3.79586 14.1154Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6293 2.74999C10.6293 1.88017 11.5077 1.27675 12.3342 1.57884L17.3958 3.42904C17.8922 3.61049 18.2216 4.07773 18.2216 4.60018V15.1401C18.2216 15.6625 17.8922 16.1297 17.3958 16.3112L12.3342 18.1614C11.5077 18.4635 10.6293 17.8601 10.6293 16.9902V2.74999ZM12.8616 0.173478C11.0433 -0.491136 9.11084 0.836375 9.11084 2.74999V16.9902C9.11084 18.9038 11.0433 20.2314 12.8616 19.5667L17.9232 17.7166C19.0153 17.3173 19.7402 16.2894 19.7402 15.1401V4.60018C19.7402 3.45079 19.0153 2.42287 17.9232 2.02367L12.8616 0.173478Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27166 7.34155C4.56816 7.04891 5.04888 7.04891 5.34538 7.34155L7.37003 9.33978C7.66652 9.63243 7.66652 10.1068 7.37003 10.3994L5.34538 12.3976C5.04888 12.6903 4.56816 12.6903 4.27166 12.3976C3.97515 12.1051 3.97515 11.6306 4.27166 11.338L5.00019 10.619H0.759239C0.339927 10.619 0 10.2835 0 9.86961C0 9.45576 0.339927 9.12027 0.759239 9.12027H5.00019L4.27166 8.40123C3.97515 8.10859 3.97515 7.63418 4.27166 7.34155Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.5c1b2055992d8edd6688c6671d951572.svg";
export { ForwardRef as ReactComponent };